import React, { useState } from "react";
import ChatRoom from "../components/ChatRoom";
import Loader from "../../commoncomponents/Loader";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import Cookies from "universal-cookie";
import { useToast } from "../../commoncomponents/ToastProvider";
import { useEffect } from "react";
const Rooms = (props) => {
  const [loading, setLoading] = useState(false);
  const [admin, setAdmin] = useState([]); // this seems unused, can remove
  const [member, setMember] = useState([]);
  const [openRoom, setOpenRoom] = useState(false);
  const [selected, setSelected] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const [getTotalCount, setTotalCount] = useState(0);
  const [getAgentList, setAgentList] = useState([{}]);
  const [getRoomList, setRoomList] = useState([{}]);
  const [showAgentModal, setShowAgentModal] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [roomDetails, setRoomDetails] = useState(null);
  const [selectedAgentsToAdd, setSelectedAgentsToAdd] = useState([]);
  const [selectedAgentsToRemove, setSelectedAgentsToRemove] = useState([]);

  const cookie = new Cookies();
  const { showToast } = useToast();

  const search_agent = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/agent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin") }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          setAgentList(dataset.data.data);
        } else {
          showToast("Failed to fetch search results", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching search results for data details", error);
      showToast(
        "Network error occured while fetching data details, please try again later",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const get_rooms = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/getrooms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin") }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          setRoomList(dataset.data.data);
        } else {
          showToast("Failed to fetch search results", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching search results for data details", error);
      showToast(
        "Network error occured while fetching data details, please try again later",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAdminChange = (event) => {
    setAdmin(event.target.value); // Update admin state instead of selected
  };

  const handleMemberChange = (event) => {
    setMember(event.target.value);
  };

  const create_room = async () => {
    const roomName = document.getElementById("namehere").value;

    // Validate room name
    if (!roomName || !roomName.trim()) {
      showToast("Please enter a room name", "error");
      return;
    }

    // Validate that at least one member is selected
    if (!member || member.length === 0) {
      showToast("Please select at least one member for the room", "error");
      return;
    }

    try {
      setLoading(true);
      const resp = await fetch(
        `${process.env.REACT_APP_URL}/admin/createroom`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            token: cookie.get("admin"),
            name: roomName.trim(),
            member: member,
            admin: admin,
          }),
        }
      );
      console.log(resp.status, "create_room status");
      if (resp.status == 200) {
        const dataset = await resp.json()
        if (dataset.status == true) {
          showToast("Room created successfully", "success");
          // Clear form
          document.getElementById("namehere").value = "";
          setMember([]);
          setAdmin([]);
          get_rooms();
        } else {
          showToast(dataset.err?.msg || dataset.error?.msg || "Failed to create room", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Network error occurred while creating room", "error");
    } finally {
      setLoading(false);
    }
  };

  const get_room_details = async (roomId) => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/roomdetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ 
          token: cookie.get("admin"),
          room_id: roomId 
        }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          setRoomDetails(dataset.data);
          return dataset.data;
        } else {
          showToast("Failed to fetch room details", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching room details", error);
      showToast("Network error occurred while fetching room details", "error");
    } finally {
      setLoading(false);
    }
  };

  const add_agent_to_room = async (roomId, agentId) => {
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/addagent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          room_id: roomId,
          agent_id: agentId,
        }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          showToast(`${dataset.data.agent_name} added to ${dataset.data.room_name}`, "success");
          return true;
        } else {
          showToast(dataset.error?.msg || "Failed to add agent", "error");
          return false;
        }
      }
    } catch (error) {
      console.log("Error adding agent to room", error);
      showToast("Network error occurred", "error");
      return false;
    }
  };

  const remove_agent_from_room = async (roomId, agentId) => {
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/removeagent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          room_id: roomId,
          agent_id: agentId,
        }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          showToast(`${dataset.data.agent_name} removed from ${dataset.data.room_name}`, "success");
          return true;
        } else {
          showToast(dataset.error?.msg || "Failed to remove agent", "error");
          return false;
        }
      }
    } catch (error) {
      console.log("Error removing agent from room", error);
      showToast("Network error occurred", "error");
      return false;
    }
  };

  const bulk_update_agents = async (roomId, agentsToAdd, agentsToRemove) => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/bulkupdateagents`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("admin"),
          room_id: roomId,
          agents_to_add: agentsToAdd,
          agents_to_remove: agentsToRemove,
        }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          const { added_agents, removed_agents, errors } = dataset.data;
          let message = "Room updated successfully! ";
          if (added_agents.length > 0) {
            message += `Added: ${added_agents.map(a => a.name).join(", ")}. `;
          }
          if (removed_agents.length > 0) {
            message += `Removed: ${removed_agents.map(a => a.name).join(", ")}. `;
          }
          if (errors.length > 0) {
            message += `Errors: ${errors.join(", ")}`;
          }
          showToast(message, "success");
          return true;
        } else {
          showToast(dataset.error?.msg || "Failed to update agents", "error");
          return false;
        }
      }
    } catch (error) {
      console.log("Error updating agents", error);
      showToast("Network error occurred", "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const open_agent_modal = async (room) => {
    setSelectedRoom(room);
    await get_room_details(room.id);
    setShowAgentModal(true);
  };

  const close_agent_modal = () => {
    setShowAgentModal(false);
    setSelectedRoom(null);
    setRoomDetails(null);
    setSelectedAgentsToAdd([]);
    setSelectedAgentsToRemove([]);
  };

  const handle_agents_to_add_change = (event) => {
    setSelectedAgentsToAdd(event.target.value);
  };

  const handle_agents_to_remove_change = (event) => {
    setSelectedAgentsToRemove(event.target.value);
  };

  const apply_agent_changes = async () => {
    if (selectedAgentsToAdd.length === 0 && selectedAgentsToRemove.length === 0) {
      showToast("No changes to apply", "info");
      return;
    }

    const success = await bulk_update_agents(
      selectedRoom.id,
      selectedAgentsToAdd,
      selectedAgentsToRemove
    );

    if (success) {
      // Refresh room details and room list
      await get_room_details(selectedRoom.id);
      await get_rooms();
      setSelectedAgentsToAdd([]);
      setSelectedAgentsToRemove([]);
    }
  };

  useEffect(() => {
    search_agent();
    get_rooms();
  }, [""]);

  const commonStyles = {
    width: 210,
    color: "white",
    fontSize: "14px",
    "& .MuiOutlinedInput-root": {
      color: "white",
      fontSize: "14px",
      padding: 0,
      "& .MuiSelect-select": {
        padding: "6px 8px",
      },
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
      "& svg": {
        color: "white",
      },
    },
    "& .MuiInputLabel-root": {
      color: "white",
      fontSize: "14px",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "white",
    },
    "& .MuiMenuItem-root": {
      color: "white",
      fontSize: "14px",
    },
  };

  return (
    <>
      <div className="agent_wrapper">
        <div className="top_search_fields">
          <div className="fields_row">
            <div className="fields_item">
              <label>Room Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter room name"
                id="namehere"
              />
            </div>

            <div className="fields_item">
              <label>Admins</label>
              <FormControl sx={commonStyles}>
                <InputLabel shrink id="multi-select-label">
                  Select Admins
                </InputLabel>
                <Select
                  labelId="multi-select-label"
                  multiple
                  value={admin} // selected is array of IDs
                  onChange={handleAdminChange}
                  input={<OutlinedInput notched label="Select Admins" />}
                  renderValue={(selectedIds) =>
                    selectedIds
                      .map((id) => {
                        const agent = getAgentList.find((a) => a.id === id);
                        return agent ? agent.name : id;
                      })
                      .join(", ")
                  }
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: "#1e293b",
                        color: "white",
                        mt: 1,
                        "& .MuiMenuItem-root": {
                          fontSize: "14px",
                        },
                        "& .MuiTypography-root": {
                          fontSize: "14px",
                        },
                        "& .MuiCheckbox-root": {
                          padding: "4px",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: "18px",
                        },
                      },
                    },
                  }}
                >
                  {getAgentList.map((e) => (
                    <MenuItem key={e.id} value={e.id}>
                      <Checkbox
                        checked={admin.indexOf(e.id) > -1}
                        sx={{ color: "white" }}
                      />
                      <ListItemText primary={e.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Members Multi Select */}
            <div className="fields_item">
              <label>Members</label>
              <FormControl sx={commonStyles}>
                <InputLabel shrink id="multi-member-label">
                  Select Members
                </InputLabel>
                <Select
                  labelId="multi-select-label"
                  multiple
                  value={member} // selected is array of IDs
                  onChange={handleMemberChange}
                  input={<OutlinedInput notched label="Select Admins" />}
                  renderValue={(selectedIds) =>
                    selectedIds
                      .map((id) => {
                        const agent = getAgentList.find((a) => a.id === id);
                        return agent ? agent.name : id;
                      })
                      .join(", ")
                  }
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: "#1e293b",
                        color: "white",
                        mt: 1,
                        "& .MuiMenuItem-root": {
                          fontSize: "14px",
                        },
                        "& .MuiTypography-root": {
                          fontSize: "14px",
                        },
                        "& .MuiCheckbox-root": {
                          padding: "4px",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: "18px",
                        },
                      },
                    },
                  }}
                >
                  {getAgentList.map((e) => (
                    <MenuItem key={e.id} value={e.id}>
                      <Checkbox
                        checked={member.indexOf(e.id) > -1}
                        sx={{ color: "white" }}
                      />
                      <ListItemText primary={e.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="btn_container">
            <button
              onClick={(e) => {
                create_room();
              }}
            >
              {loading ? <Loader loading={loading} /> : "Create Room"}
            </button>
          </div>

          {/* Pagination Select */}
          <div style={{ textAlign: "right", marginRight: "20px" }}>
            <select
              defaultValue={paginationModel.pageSize}
              onChange={(e) => {
                setPaginationModel({
                  ...paginationModel,
                  pageSize: Number(e.target.value),
                });
              }}
            >
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table_container">
          <table>
            <thead>
              <tr>
                <th>Room Name</th>
                <th>Current Members</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {getRoomList.map((e) => {
                return (
                  <tr key={e.id}>
                    <td>{e.name}</td>
                    <td>
                      <div className="members_list">
                        {e.member && e.member.length > 0 ? (
                          <div className="member_tags">
                            {e.member.slice(0, 3).map((memberId) => (
                              <span key={memberId} className="member_tag">
                                {e.names?.[memberId] || memberId}
                              </span>
                            ))}
                            {e.member.length > 3 && (
                              <span className="member_tag more">
                                +{e.member.length - 3} more
                              </span>
                            )}
                          </div>
                        ) : (
                          <span className="no_members">No members</span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div
                        className="btn_container"
                        style={{ justifyContent: "flex-start", gap: "10px" }}
                      >
                        <button onClick={() => setOpenRoom(true)}>
                          Open Room
                        </button>
                        <button 
                          onClick={() => open_agent_modal(e)}
                          className="manage_agents_btn"
                        >
                          Manage Agents
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination Buttons */}
        <div className="btn_container">
          {paginationModel.page > 0 && (
            <button
              className="table_btn"
              onClick={() =>
                setPaginationModel({
                  ...paginationModel,
                  page: paginationModel.page - 1,
                })
              }
            >
              Back
            </button>
          )}

          <button className="table_btn">
            {paginationModel.page + 1} of{" "}
            {Math.max(1, Math.ceil(getTotalCount / paginationModel.pageSize))}
          </button>

          {paginationModel.page + 1 <
            getTotalCount / paginationModel.pageSize && (
              <button
                className="table_btn"
                onClick={() =>
                  setPaginationModel({
                    ...paginationModel,
                    page: paginationModel.page + 1,
                  })
                }
              >
                Next
              </button>
            )}
        </div>
      </div>

      {openRoom && <ChatRoom openRoom={openRoom} setOpenRoom={setOpenRoom} />}
      
      {/* Agent Management Modal */}
      {showAgentModal && selectedRoom && roomDetails && (
        <div className="modal_overlay">
          <div className="modal_content agent_modal">
            <div className="modal_header">
              <h3>Manage Agents - {selectedRoom.name}</h3>
              <button className="close_btn" onClick={close_agent_modal}>
                ×
              </button>
            </div>
            
            <div className="modal_body">
              {/* Current Members Section */}
              <div className="section">
                <h4>Current Members ({roomDetails.members?.length || 0})</h4>
                <div className="agents_list current_members">
                  {roomDetails.members && roomDetails.members.length > 0 ? (
                    roomDetails.members.map((member) => (
                      <div key={member.id} className="agent_item">
                        <div className="agent_info">
                          <span className="agent_name">{member.name}</span>
                          <span className="agent_email">{member.email}</span>
                          <span className={`agent_status ${member.status ? 'active' : 'inactive'}`}>
                            {member.status ? 'Active' : 'Inactive'}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="no_data">No members in this room</p>
                  )}
                </div>
              </div>

              {/* Add Agents Section */}
              <div className="section">
                <h4>Add Agents</h4>
                <FormControl sx={{...commonStyles, width: '100%'}}>
                  <InputLabel shrink id="add-agents-label">
                    Select Agents to Add
                  </InputLabel>
                  <Select
                    labelId="add-agents-label"
                    multiple
                    value={selectedAgentsToAdd}
                    onChange={handle_agents_to_add_change}
                    input={<OutlinedInput notched label="Select Agents to Add" />}
                    renderValue={(selectedIds) =>
                      selectedIds
                        .map((id) => {
                          const agent = roomDetails.available_agents?.find((a) => a.id === id);
                          return agent ? agent.name : id;
                        })
                        .join(", ")
                    }
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: "#1e293b",
                          color: "white",
                          mt: 1,
                        },
                      },
                    }}
                  >
                    {roomDetails.available_agents?.map((agent) => (
                      <MenuItem key={agent.id} value={agent.id}>
                        <Checkbox
                          checked={selectedAgentsToAdd.indexOf(agent.id) > -1}
                          sx={{ color: "white" }}
                        />
                        <ListItemText 
                          primary={agent.name} 
                          secondary={agent.email}
                          sx={{
                            "& .MuiListItemText-primary": {
                              color: "white",
                            },
                            "& .MuiListItemText-secondary": {
                              color: "#94a3b8",
                            },
                          }}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              {/* Remove Agents Section */}
              <div className="section">
                <h4>Remove Agents</h4>
                <FormControl sx={{...commonStyles, width: '100%'}}>
                  <InputLabel shrink id="remove-agents-label">
                    Select Agents to Remove
                  </InputLabel>
                  <Select
                    labelId="remove-agents-label"
                    multiple
                    value={selectedAgentsToRemove}
                    onChange={handle_agents_to_remove_change}
                    input={<OutlinedInput notched label="Select Agents to Remove" />}
                    renderValue={(selectedIds) =>
                      selectedIds
                        .map((id) => {
                          const agent = roomDetails.members?.find((a) => a.id === id);
                          return agent ? agent.name : id;
                        })
                        .join(", ")
                    }
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: "#1e293b",
                          color: "white",
                          mt: 1,
                        },
                      },
                    }}
                  >
                    {roomDetails.members?.map((agent) => (
                      <MenuItem key={agent.id} value={agent.id}>
                        <Checkbox
                          checked={selectedAgentsToRemove.indexOf(agent.id) > -1}
                          sx={{ color: "white" }}
                        />
                        <ListItemText 
                          primary={agent.name} 
                          secondary={agent.email}
                          sx={{
                            "& .MuiListItemText-primary": {
                              color: "white",
                            },
                            "& .MuiListItemText-secondary": {
                              color: "#94a3b8",
                            },
                          }}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="modal_footer">
              <button className="btn_secondary" onClick={close_agent_modal}>
                Cancel
              </button>
              <button 
                className="btn_primary" 
                onClick={apply_agent_changes}
                disabled={loading}
              >
                {loading ? <Loader loading={loading} /> : "Apply Changes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Rooms;
